import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import DataTable from 'react-data-table-component';
import { api } from '../api';

function Transactions() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({});
  const [selected, setSelected] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalError, setModalError] = useState('');

  useEffect(() => {
    setLoading(true);
    api.getTransactions(page, limit, filters).then(res => {
      setTransactions(res.transactions);
      setPage(res.page);
      setLimit(res.limit);
      setTotal(res.total);
      setLoading(false);
    });
  }, [page, limit, filters]);

  async function openTransaction(tx) {
    setModalError('');
    setModalLoading(true);
    const detail = await api.getTransactionById(tx.txRef);
    setSelected(detail);
    setModalLoading(false);
    try {
      const el = document.getElementById('transactionModal');
      if (el && window.bootstrap) (window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el)).show();
    } catch {}
  }

  const columns = [
    { name: 'ID', selector: row => row.id, sortable: true },
    { name: 'Reference', selector: row => row.txRef, sortable: true },
    { name: 'Amount', selector: row => `$${row.amount?.toFixed(2)}`, sortable: true },
    { name: 'Total', selector: row => `$${row.totalAmount?.toFixed(2)}`, sortable: true },
    { name: 'Status', selector: row => row.status, sortable: true, cell: row => (
      <span className={`ec-status ${row.status === 'PAID' ? 'ec-active' : row.status === 'PENDING' ? 'ec-pending' : row.status === 'FAILED' ? 'ec-inactive' : ''}`}>{row.status}</span>
    ) },
    { name: 'Type', selector: row => row.type, sortable: true },
    { name: 'Date', selector: row => new Date(row.createdAt).toLocaleString(), sortable: true },
    { name: 'Action', cell: row => (
      <button className="btn btn-outline-success" onClick={() => openTransaction(row)}>View</button>
    ), ignoreRowClick: true, allowOverflow: true, button: true },
  ];

  return (
    <>
      <Helmet><title>Transactions | Owena Admin Dashboard</title></Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Transactions</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={e=>e.preventDefault()}>Home</a></span><span><i className="mdi mdi-chevron-right"></i></span>Transactions</p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="ec-vendor-list card card-default">
                <div className="card-body">
                  <DataTable
                    columns={columns}
                    data={transactions}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={total}
                    paginationPerPage={limit}
                    paginationDefaultPage={page}
                    onChangePage={setPage}
                    onChangeRowsPerPage={setLimit}
                    highlightOnHover
                    pointerOnHover
                    responsive
                    noDataComponent={<div className="text-center">No transactions found.</div>}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Transaction Modal */}
          <div className="modal fade" id="transactionModal" tabIndex="-1" aria-labelledby="transactionModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered"><div className="modal-content">
              <div className="modal-header px-4"><h5 className="modal-title" id="transactionModalLabel">Transaction</h5><button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div>
              <div className="modal-body px-4">
                {modalLoading && <div className="text-center py-3"><span className="spinner-border" role="status" /></div>}
                {modalError && <div className="alert alert-danger py-2 mb-2">{modalError}</div>}
                {selected && !modalLoading ? (
                  <div>
                    <div className="row mb-3">
                      <div className="col-md-6"><strong>ID:</strong> {selected.id}</div>
                      <div className="col-md-6"><strong>Reference:</strong> {selected.txRef}</div>
                    </div>
                    <div className="mb-3"><strong>Status:</strong> {selected.status}</div>
                    <div className="mb-3"><strong>Type:</strong> {selected.type}</div>
                    <div className="mb-3"><strong>Amount:</strong> ${selected.amount?.toFixed(2)}</div>
                    <div className="mb-3"><strong>Total:</strong> ${selected.totalAmount?.toFixed(2)}</div>
                    <div className="mb-3"><strong>Platform Fee:</strong> ${selected.platformFee?.toFixed(2)}</div>
                    <div className="mb-3"><strong>Transaction Fee:</strong> ${selected.transactionFee?.toFixed(2)}</div>
                    <div className="mb-3"><strong>Delivery Fee:</strong> ${selected.deliveryFee?.toFixed(2)}</div>
                    <div className="mb-3"><strong>Payment Method:</strong> {selected.paymentMethod}</div>
                    <div className="mb-3"><strong>Date:</strong> {new Date(selected.createdAt).toLocaleString()}</div>
                    {selected.order && (
                      <div className="mb-3"><strong>Order ID:</strong> {selected.order.id} <br /><strong>Order Status:</strong> {selected.order.status}</div>
                    )}
                  </div>
                ) : null}
              </div>
            </div></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Transactions;
